/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![HeadphonesIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACGUlEQVR4nNVVzWsUUQx/PfiJVNSrpcWLtP+CiIoggzsvyS68Jt0ilUUX9CKKN4uW/g39O1p66aWCIN5sFb0sKlor9lihfp78IDNvd2Z3Z6ajK4iBB0Mm+f2SvCTPmH8pzrnDIU5dB+IlQH5rUb7qib6JFy3xtSCYHv5t4CAI9gHJvCX5CCQ/i47aWOQ559zeUuAXa/VRS/w8BbCKOHWFiMedc4f06DeQXAWS+wkZP0PkkULwSq1+AkjeRw7ILYDJc7sFFCKftygvfDDvEHks09A5d8ASP43B5VGlUj9SKuXY96j6eN/1MzMz+/uMgOSeT/eNXm5Z8LZo6QD5pS/XHZMWjdaifIrSrE2eMn8oiHzaE+x0BamX6Gv4wAwoluShr0Sjo4z6XAmQLw9KACQNn8VSmnUjUoI7OTABuAmfwatEifxNlWEYHhyUwOllxxl87iPQn3+PQL6kCV53rwD+ACgrZQYNkc+qrUXZ7lkjSYks8XLOrvkBxLfywAHkZmyT5Zu65Hab5pHYqgS94CHxBYv8vcCv0TVoOhz5G5O3iC4da9vrt+rywXmnb9UA8d3CtYy80Ckp8sIua3w28w2wxGsFTptJMH7jZmf7WLHyOmJMX6tMZ+RWkkG8njMenw19T/Kaok0y0lnb1FXXGz3d0xv5k2p1+rgpI81mc4/WMZoP5FaIfNsYM5QyGdL21V73MzSrPqXA/zv5BUvAqNMQCTVeAAAAAElFTkSuQmCC)
 */
export const HeadphonesIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M12 3a9 9 0 0 0-8.95 10h1.87a5 5 0 0 1 4.1 2.13l1.37 1.97a3.1 3.1 0 0 1-.17 3.78 2.85 2.85 0 0 1-3.55.74 11 11 0 1 1 10.66 0c-1.27.71-2.73.23-3.55-.74a3.1 3.1 0 0 1-.17-3.78l1.38-1.97a5 5 0 0 1 4.1-2.13h1.86A9 9 0 0 0 12 3Z"
        className={colorClass}
      />
    </svg>
  );
};
